import React from 'react';
import {observer} from 'mobx-react';
import {OrbitSuspense} from '../base-components/orbit-suspense/orbit-suspense';
import {TopImageComponent} from '../top-image/top-image.component';
import {LobbyHeaderComponent} from '../lobby-header/lobby-header.component';
import {IStickyHandler} from '../sticky-handler/sticky-handler.interface';
import {RoutedComponent} from '../base-components/routed-component/routed.component';
import {GamingHistoryPageBox} from "./boxes/gaming-history-page/gaming-history-page.box";
import {GamingHistoryType} from "../../services/gaming-history/gaming-history-type";
import {GamingHistoryComponent} from "./gaming-history.component";


interface GamingHistoryPageComponentProps {
    historyType: GamingHistoryType;
    showMoreDetailsLink: boolean;
    redirectHomeIfUnauthorized: boolean;
}

@observer
export class GamingHistoryPageComponent extends RoutedComponent<GamingHistoryPageComponentProps> {

    private _getHistoryPageConfiguration() {
        if (this.props.historyType === GamingHistoryType.JackpotBetsGamingHistory && this.services.jackpotBet.isEnabled) {
            return this.services.configuration.data.jpBetHistoryPage;
        }

        switch (this.props.historyType) {
            case GamingHistoryType.UserHistory:
                return this.services.configuration.data.historyPage;
            case GamingHistoryType.SessionHistory:
                return this.services.configuration.data.sessionHistoryPage;
            default:
                this.services.logger.error(`Invalid history type ${this.props.historyType}`);
                return null;
        }
    }


    private _stickyHandler: IStickyHandler;
    private get stickyHandler(): IStickyHandler {
        if (!this._stickyHandler) {
            this._stickyHandler = this.services.stickyHandlerFactory.createStickyHandler();
        }

        return this._stickyHandler;
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.stickyHandler.dispose();
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.historyType === GamingHistoryType.SessionHistory) {
            this.services.analytics.sendTechnicalEvent('session_history_displayed', 'session_history');
        }
    }

    render() {
        let historyPageConfig = this._getHistoryPageConfiguration();
        if (!historyPageConfig) {
            return null;
        }

        return (
            <>
                <TopImageComponent image={historyPageConfig.topImage} />
                <LobbyHeaderComponent
                    title={historyPageConfig.title}
                    stickyHandler={this.stickyHandler}
                    showSearchIcon={false}
                />
                <GamingHistoryPageBox>
                    <OrbitSuspense>
                        <GamingHistoryComponent
                            historyType={this.props.historyType}
                            showMoreDetails={this.props.showMoreDetailsLink}
                            redirectHomeIfUnauthorized={this.props.redirectHomeIfUnauthorized}
                        />
                    </OrbitSuspense>
                </GamingHistoryPageBox>
            </>
        )
    }
}